import programsJson from '../config/programs.json'
import { TIME_ZONE } from '../config/board'

// Which list is main on which screen, per time of day. A JSON file until changing a
// window by deploy actually hurts (build-guide §2 / the contract's "Programs" block);
// the shape is the one the contract specifies, so promoting it to a table later is a
// data move, not a rewrite.

export type ScreenId = '1' | '2'

export interface ScreenConfig {
  /** Category name of the main list. */
  main: string
  hero?: string
  /** Category names of the columns under the main list. */
  extra?: string[]
  footer?: string
}

export interface Program {
  id: string
  /** Reserved by the contract; every program is "*" today and the day is not read. */
  days: string
  from: string
  to: string
  screens: Record<ScreenId, ScreenConfig>
}

export const PROGRAMS: Program[] = (programsJson as { programs: Program[] }).programs

function minutes(hhmm: string): number {
  const parts = hhmm.split(':')
  return Number(parts[0]) * 60 + Number(parts[1])
}

/**
 * The program whose window contains `hhmm` (`from` inclusive, `to` exclusive).
 * Outside every window the last program of the day stays up, so the wall never
 * falls back to nothing between closing and opening.
 */
export function pickProgram(programs: Program[], hhmm: string): Program {
  const t = minutes(hhmm)
  const match = programs.filter((p) => t >= minutes(p.from) && t < minutes(p.to))[0]
  if (match) return match
  const byStart = programs.slice().sort((a, b) => minutes(a.from) - minutes(b.from))
  return byStart[byStart.length - 1]
}

/** `HH:MM` in the shop's timezone, not the browser's. */
export function hhmmNow(now: Date, timeZone: string = TIME_ZONE): string {
  return new Intl.DateTimeFormat('en-GB', {
    timeZone,
    hour: '2-digit',
    minute: '2-digit',
    hourCycle: 'h23',
  }).format(now)
}

/** `?at=HH:MM` previews the program of another moment; anything else is ignored. */
export function atOverride(search: string): string | null {
  const at = new URLSearchParams(search).get('at')
  if (at && /^([01][0-9]|2[0-3]):[0-5][0-9]$/.test(at)) return at
  return null
}
